import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ProductAction } from '@stores/product/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav  from '@components/tabNav';
// import ActivityList from '@components/productList';
import TabFilter  from '@components/tabFilter';

interface ProductDetailPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    product?: ProductAction;
    productDetail?: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navCurrentType?: any
    navClick?: Function
    productCodeData?: any
    productCodeList?: any
}
interface ProductDetailPCState {
    loading: boolean;
    error: any
    pageLoaded: any
}
@inject('app', 'site', 'user', 'product')
@observer
class ProductDetailPCPage extends BasePage<ProductDetailPCPageProps, ProductDetailPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };
    componentDidMount() {
        super.componentDidMount();
        this.props.history.push(`/downloadAppEnter`);
    }

    render() {
        let { navList, navCurrentIndex, navClick } = this.props;

        return (<div className={styles.wrapper}>
            
        </div>)
    }
}

export default withRouter(ProductDetailPCPage);
